'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _themeSections = require('@shopify/theme-sections');

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

require('../../styles/sections/ingredients-listing.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _themeSections.register)('ingredient-nav', {
  onLoad: function onLoad() {
    (0, _jquery2.default)(document).on('click', 'a[href^="#"]', function (event) {
      event.preventDefault();

      (0, _jquery2.default)('html, body').animate({
        scrollTop: (0, _jquery2.default)(_jquery2.default.attr(this, 'href')).offset().top - 199
      }, 500);
    });

    if ((0, _jquery2.default)(window).width() < 650) {
      (0, _jquery2.default)(document).on('click', 'h3.small-accordion', function (event) {
        event.preventDefault();
        if ((0, _jquery2.default)(this).hasClass('active')) {
          (0, _jquery2.default)(this).removeClass('active');
          (0, _jquery2.default)(this).siblings('.ingredients-container').slideUp(500);
        } else {
          (0, _jquery2.default)(this).siblings('h3.small-accordion').removeClass('active');
          (0, _jquery2.default)(this).siblings('.ingredients-container').slideUp(500);
          (0, _jquery2.default)(this).addClass('active');
          (0, _jquery2.default)(this).next('.ingredients-container').slideDown(500);
        }
      });
    } else {
      (0, _jquery2.default)('.masonry').show();
    }
  }
});